module.exports = __webpack_public_path__ + "img/back.398dcfb6.svg";